import React from "react";
import { Container, Grid } from "@mui/material";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Heading from "../../components/Heading/heading";

import tweet1 from '../../image/tweet1.png'
import tweet2 from '../../image/tweet2.png'
import tweet3 from '../../image/tweet3.png'
const ElonsTweet = () => {
    return(
        <Container maxWidth="lg" className="py-5">
            <Grid
                container
                justifyContent="flex-start"
                alignItems="center"
            >
                <Grid
                    xs={12}
                    className="text-center mb-dm-5"
                >
                    <Heading
                        subtitle="Elon's Twitter"
                        title="Latest Crypto related Tweets"
                    />
                </Grid>
                
                <Grid
                    xs={12}
                    sm={6}
                    md={4}
                    className="text-left mt-4"
                >
                    <Card className="mx-auto" sx={{ maxWidth: 345 }} style={{borderRadius: 35}}>
                        <CardMedia
                            component="img"
                            height="240"
                            image={tweet1}
                            alt="Elon is Looking for shiba pup."
                            className="my-4"
                        />
                        <CardContent className="px-4 px-md-5 py-4" style={{backgroundImage: 'linear-gradient(-45deg, #6829B3, #7A2BD8, #8D2EFF)'}} >
                            <Typography gutterBottom variant="h5" component="div" color="#fff">
                                @elonmusk
                            </Typography>
                            <p className="text-light mb-0">
                                Looking for shiba pup.
                            </p>
                        </CardContent>
                    </Card>
                </Grid>
                
                <Grid
                    xs={12}
                    sm={6}
                    md={4}
                    className="text-left mt-4"
                >
                    <Card className="mx-auto" sx={{ maxWidth: 345 }} style={{borderRadius: 35}}>
                        <CardMedia
                            component="img"
                            height="240"
                            image={tweet2}
                            alt="Elon is Looking for shiba pup."
                            className="my-4"
                        />
                        <CardContent className="px-4 px-md-5 py-4" style={{backgroundImage: 'linear-gradient(-45deg, #6829B3, #7A2BD8, #8D2EFF)'}} >
                            <Typography gutterBottom variant="h5" component="div" color="#fff">
                                @elonmusk
                            </Typography>
                            <p className="text-light mb-0">
                                Invest with caution.
                            </p>
                        </CardContent>
                    </Card>
                </Grid>
                
                
                <Grid
                    xs={12}
                    sm={6}
                    md={4}
                    className="text-left mt-4"
                >
                    <Card className="mx-auto" sx={{ maxWidth: 345 }} style={{borderRadius: 35}}>
                        <CardMedia
                            component="img"
                            height="240"
                            image={tweet3}
                            alt="Elon is Looking for shiba pup."
                            className="my-4"
                        />
                        <CardContent className="px-4 px-md-5 py-4" style={{backgroundImage: 'linear-gradient(-45deg, #6829B3, #7A2BD8, #8D2EFF)'}} >
                            <Typography gutterBottom variant="h5" component="div" color="#fff">
                                @elonmusk
                            </Typography>
                            <p className="text-light mb-0">
                                It's inevitable.
                            </p>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    )
}

export default ElonsTweet;